import { type SxProps, type Theme } from '@mui/material';

export const TOP_BAR_HEIGHT = 64;

export const TopBarStyles: SxProps<Theme> = {
  alignItems: 'center',
  backgroundColor: 'white',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  color: 'black',
  display: 'flex',
  flexShrink: 0,
  height: TOP_BAR_HEIGHT,
  justifyContent: 'space-between',
  position: 'sticky',
  px: 5,
  top: 0,
  width: '100%',
  zIndex: 500,
};

export const TopBarItemsStyles: SxProps<Theme> = {
  alignItems: 'center',
  gap: 1,
  justifyContent: 'space-between',
};
